import { VersionNumber } from "../data_layer/data/VersionNumber";
import { FormatDate } from "./FormatDate";


function ConvertDemographicsToString(facility, patients){
    // Convert the data array into a CSV string
    let csvString = `Facility, ${facility.name}\n`;
    csvString += `Facility ID, ${facility.id}\n`;
    csvString += `Download Date, ${FormatDate(Date.now()/1000)}\n\n`;

    csvString += `Patient ID, Name, UUID, Patient Status, Admission Status, Birth weight, Weight Units, Conceptual Age (weeks), Date of conception, Gestational age (weeks), Total feedings, User ID, created at, updated at\n`;
        

    patients.forEach(p => {

        csvString += `${p.ehr_patient_ref}, ${p.name.replace(/,/g, ' ')},${p.patient_id},${p.patient_status},${p.admission_status}, ${p.birth_weight}, ${p.weight_uom},${p.conceptual_age},${FormatDate(p.date_of_conception)},${p.gestational_age},${p.total_feedings},${p.user_id},${FormatDate(p.created_at)},${FormatDate(p.updated_at)}\n`;

    });


    return csvString;
};

export default ConvertDemographicsToString;